/* unplugin-vue-components disabled */import script from "./Identity.vue?vue&type=script&setup=true&lang=js"
export * from "./Identity.vue?vue&type=script&setup=true&lang=js"

import "./Identity.vue?vue&type=style&index=0&id=69b5a821&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69b5a821"]])

export default __exports__